export default __webpack_public_path__ + "static/media/sitme.a130d950.jpg";